import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import { storedNameOf } from '../storage/deviceStorage';

const isDev = process.env.NODE_ENV !== 'production';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        returnEmptyString: false,
        supportedLngs: ['en', 'hi'],
        ns: ['common'],
        defaultNS: 'common',

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: storedNameOf('language'),
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },

        saveMissing: isDev,
        missingKeyHandler: isDev
            ? (_lngs: readonly string[], ns: string, key: string, fallbackValue: string) => {
                console.warn(`[i18n] Missing key: "${ns}:${key}" → fallback: "${fallbackValue}"`);
            }
            : false,
    });

const syncDocumentLanguage = (lng: string): void => {
    if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', lng);
};
if (i18n.language) syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
